import { useContext } from 'react';
import { ThemeContext } from 'styled-components';
import PropTypes from '@userzoomlibraries/toolkit-js-utils/prop-types';

/**
 * @license
 * This source code is and remains the property of UserZoom Technologies Inc (sucursal en España).
 * Dissemination of this information or reproduction of this material is strictly
 * forbidden unless prior written permission is obtained from
 * UserZoom Technologies Inc (sucursal en España) (https://www.userzoom.com).
 */
/**
 * Hook to get the theme object from context.
 *
 * @function
 * @returns {object} Returns the context object of the theme.
 * @example
 * useTheme();
 * // => { [Button.COMPONENT_ID]: '...', ... }
 */

var useTheme = function useTheme() {
  return useContext(ThemeContext) || {};
};

useTheme.HOOK_ID = 'Gearz.ThemeManager.useTheme';
useTheme.returnType = PropTypes.objectWithDescription('Object with key/value of components and their themes.');
useTheme.parameterTypes = {};
useTheme.defaultParameters = {};

export { useTheme as default };
